import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class FeatureTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "ledColumn", title: "Mode" },
        { name: "blueColumn", title: "Blue LED" },
        { name: "redColumn", title: "Red LED" },
      ],
      rows: [
        { ledColumn: 'Constant on', blueColumn: 'Connected to WiFi', redColumn: 'N/A' },
        { ledColumn: 'Slow Flashing', blueColumn: 'Connecting via WPS', redColumn: 'Camera operational' },
        { ledColumn: 'Fast Flashing', blueColumn: 'No connection to WiFi', redColumn: 'Upgrading firmware' },
        { ledColumn: 'Off', blueColumn: 'LED is disabled or Camera has no Power', redColumn: 'LED is disabled or Camera has no Power' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

FeatureTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(FeatureTable)